/** Keys that must never be used as object property paths (prototype pollution). */
const UNSAFE_PATH_KEYS = new Set(['__proto__', 'constructor', 'prototype']);
function isSafePathSegment(segment) {
    return segment !== '' && !UNSAFE_PATH_KEYS.has(segment);
}
export function isRecord(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
/** Reads a dotted path (`text.body`) from an override object. */
export function getAtPath(target, path) {
    const segments = path.split('.');
    let current = target;
    for (const segment of segments) {
        if (!isSafePathSegment(segment) || !isRecord(current) || !Object.hasOwn(current, segment)) {
            return undefined;
        }
        current = current[segment];
    }
    return current;
}
/**
 * Sets a dotted path on a shallow-cloned object tree so nested siblings of the filled
 * key (e.g. `text.preview_url` beside `text.body`) are preserved.
 */
export function setAtPath(target, path, value) {
    const segments = path.split('.');
    if (segments.length === 0 || segments[0] === '' || !segments.every(isSafePathSegment)) {
        return { ...target };
    }
    const result = { ...target };
    let current = result;
    for (let index = 0; index < segments.length - 1; index += 1) {
        const segment = segments[index];
        const next = Object.hasOwn(current, segment) ? current[segment] : undefined;
        if (isRecord(next)) {
            current[segment] = { ...next };
        }
        else {
            current[segment] = {};
        }
        current = current[segment];
    }
    current[segments[segments.length - 1]] = value;
    return result;
}
//# sourceMappingURL=path.js.map